import React, { useEffect, useState } from "react";
import "./ViewAllNotifications.css";

import axios from "axios";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import { resources } from "../Resourses/Resources";

import {
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Button
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ViewAllNotifications = () => {
  const [open, setOpen] = useState(false);
  const [genData, setGenData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [viewFile, setViewFile] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // ---------- API ----------
  // const getGeneralNotificationsDetails = async () => {
  //   try {
  //     const res = await axios.get(
  //       resources.APPLICATION_URL + `getAllGeneralNotifications`
  //     );

  //     setGenData(res.data || []);
  //     setFilteredData(res.data || []);
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  const getGeneralNotificationsDetails = async () => {
    try {
      const res = await axios.get(
        resources.APPLICATION_URL + `getAllGeneralNotifications`
      );

      if (res.status === 200) {
        const sortedData = (res.data || []).sort(
          (a, b) => new Date(b.startDate) - new Date(a.startDate)
        );

        setGenData(sortedData);
        setFilteredData(sortedData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  useEffect(() => {
    getGeneralNotificationsDetails();
  }, []);

  // ---------- FILTER ----------
  useEffect(() => {
    let data = [...genData];

    if (searchQuery) {
      data = data.filter(
        (i) =>
          i.description?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          i.typeOfUpload?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          i.startDate?.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    if (fromDate || toDate) {
      data = data.filter((i) => {
        const d = new Date(i.startDate);
        return (!fromDate || d >= new Date(fromDate)) &&
          (!toDate || d <= new Date(toDate));
      });
    }

    setFilteredData(data);
    setCurrentPage(1);
  }, [searchQuery, fromDate, toDate, genData]);

  // ---------- PAGINATION ----------
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const currentItems = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // ---------- FILE VIEW ----------
  const handleViewFile = async (filePath) => {
    if (!filePath) return;

    const res = await axios.get(
      resources.APPLICATION_URL +
      `getFilePathtoConvertBase64?filePath=${encodeURIComponent(filePath)}`
    );

    setViewFile(res.data?.base64 || res.data);
    setOpen(true);
  };

  // ---------- DELETE ----------
  const handleNotidel = async (sno) => {
    await axios.delete(
      resources.APPLICATION_URL + `deleteGeneralNotificationByid?sno=${sno}`
    );
    getGeneralNotificationsDetails();
  };

  return (
    <>
      <div className="notify-header">
        <h2>ALL Notifications</h2>
      </div>
      <div className="notify-main">
        <div className="notify-filter-card">

          <div className="notify-search-row">
            <input
              type="text"
              placeholder="Search notifications..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          <div className="notify-date-row">
            <div className="date-box">
              <label>From</label>
              <input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>

            <div className="date-box">
              <label>To</label>
              <input
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>

            <button className="reset-btn" onClick={() => {
              setFromDate("");
              setToDate("");
              setSearchQuery("");
            }}>
              Reset
            </button>
          </div>

        </div>


        {/* ----------- TABLE ----------- */}
        <div className="notify-table-card">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Date</th>
                <th>Description</th>
                <th>Type Of Upload</th>
                {/* <th>Action</th> */}
              </tr>
            </thead>

            <tbody>
              {currentItems.length > 0 ? (
                currentItems.map((row, i) => (
                  <tr key={row.sno}>
                    <td>{(currentPage - 1) * itemsPerPage + i + 1}</td>
                    <td>{row.startDate}</td>
                    <td
                      className="notify-desc-link"
                      onClick={() => handleViewFile(row.filePath)}
                    >
                      {row.description}
                    </td>
                    <td>{row.typeOfUpload}</td>
                    {/* <td className="notify-actions">
                    <RemoveRedEyeOutlinedIcon onClick={() => handleViewFile(row.filePath)} />
                    <DeleteIcon onClick={() => handleNotidel(row.sno)} />
                  </td> */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="no-data">No Notifications Found</td>
                </tr>
              )}
            </tbody>
          </table>

          {/* ----------- PAGINATION ----------- */}
          <div className="notify-pagination">

            <div>
              Show
              <select
                value={itemsPerPage}
                onChange={(e) => setItemsPerPage(Number(e.target.value))}
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
              entries
            </div>

            <div className="page-buttons">
              <Button size="small" disabled={currentPage === 1} onClick={() => setCurrentPage(p => p - 1)}>Prev</Button>

              {[...Array(totalPages)].map((_, i) => (
                <Button
                  key={i}
                  size="small"
                  variant={currentPage === i + 1 ? "contained" : "outlined"}
                  onClick={() => setCurrentPage(i + 1)}
                >
                  {i + 1}
                </Button>
              ))}

              <Button size="small" disabled={currentPage === totalPages || totalPages === 0}
                onClick={() => setCurrentPage(p => p + 1)}>Next</Button>
            </div>
          </div>
        </div>

        {/* ----------- FILE VIEW ----------- */}
        <Dialog fullScreen open={open} onClose={() => setOpen(false)} TransitionComponent={Transition}>
          <AppBar sx={{ position: "relative" }}>
            <Toolbar>
              <IconButton edge="start" color="inherit" onClick={() => setOpen(false)}>
                <CloseIcon />
              </IconButton>
            </Toolbar>
          </AppBar>

          {viewFile && (
            <iframe
              src={`data:application/pdf;base64,${viewFile}`}
              width="100%"
              height="100%"
              title="PDF Viewer"
            />
          )}
        </Dialog>
      </div>
    </>
  );
};

export default ViewAllNotifications;
